import { useEffect, useState } from 'react';
import { IAssetFeature } from '../models';
import { useTranslation } from 'react-i18next';

export const useAssetFeatureOptions = (assetsFeatures: IAssetFeature[] | null) => {
  const { t } = useTranslation();
  const language = t('currentLanguageCode');
  const [assetFeatureOptions, setAssetFeatureOptions] = useState<{ value: string; label: string }[] | null>(null);
  useEffect(() => {
    if (!assetsFeatures) return;
    const options = assetsFeatures?.map((assetFeature) => {
      return {
        value: assetFeature._id,
        label: language === 'de' ? assetFeature.DEU : assetFeature.ENG,
      };
    });
    setAssetFeatureOptions(options);
  }, [assetsFeatures, language]);

  return assetFeatureOptions;
};
